'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagTzAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 30 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M0.999951 1C0.999951 1 1.89538 1 2.99995 1H27C28.1045 1 29 1 29 1V21C29 21 28.1045 21 27 21H2.99995C1.89538 21 0.999951 21 0.999951 21V1Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0.999951 14.3333L29 1H0.999951V14.3333Z",
          fill: "#33CC4D"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0.999951 21H29V7.66667L0.999951 21Z",
          fill: "#2DAFE4"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M8.36542 21.0078L29.012 8.06561L29 1L21.7164 0.978443L0.983557 13.9531L0.999951 21L8.36542 21.0078Z",
          fill: "#FFD84F"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M5.31233 20.992L29.0121 6.12546L29 1L24.779 0.994484L0.979095 15.8212L0.999951 21L5.31233 20.992Z",
          fill: "#262626"
        }
      )
    ]
  }
);
const VpFlagTzAsset = forwardRef(FlagTzAsset);

export { VpFlagTzAsset as default };
